import React, { useMemo } from "react";
import { connect } from "react-redux";

import AntDLayout from "antd/es/layout";

import { OrganizationSetting } from "@mapmycustomers/shared";
import defaultOrganizationLogo from "@mapmycustomers/ui/assets/logo.svg";

import localSettings from "@app/config/LocalSettings";
import { getOrganizationName, getOrganizationSettingValue } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import { complementFileUrl } from "@app/util/file";

import Menu from "./component/Menu";
import OrganizationLogo from "./component/OrganizationLogo";
import RightMenu from "./component/RightMenu";
import UserMenu from "./component/UserMenu";
import styles from "./NavigationBar.module.scss";

interface Props {
  organizationLogoUrl?: string;
  organizationName?: string;
}

export const NavigationBar = ({ organizationLogoUrl, organizationName }: Props) => {
  const logoUrl = useMemo(
    () => complementFileUrl(organizationLogoUrl) ?? defaultOrganizationLogo,
    [organizationLogoUrl]
  );

  const wasOpenedFromMobileApp = localSettings.wasOpenedFromMobileApp();

  return (
    <AntDLayout.Header className={styles.container}>
      <section className={styles.leftSection}>
        <OrganizationLogo logoUrl={logoUrl} organizationName={organizationName} />
        {wasOpenedFromMobileApp ? null : <Menu />}
      </section>
      {wasOpenedFromMobileApp ? null : (
        <section className={styles.rightSection}>
          <RightMenu />
          <UserMenu />
        </section>
      )}
    </AntDLayout.Header>
  );
};

const mapStateToProps = (state: RootState) => ({
  organizationLogoUrl: getOrganizationSettingValue(state, OrganizationSetting.LOGO),
  organizationName: getOrganizationName(state),
});

export default connect(mapStateToProps)(NavigationBar);
